<template>
  <div class="user-detail-container">
    <div v-if='user' class="user-detail-body">
      <registration-container
        v-if="user.is_paid !== '1'"
        class="mb-5"
        :start-step="3"
      ></registration-container>

      <div class="detail-item">
        <div class="detail-header">
          <div class="sub-title">
            <div class="label font-400">Ерөнхий мэдээлэл</div>
          </div>
        </div>
        <div class="detail">
          <div v-if="user.mobilenumber">
            <p class="label">Утасны дугаар:</p>
            <p class="info">{{ user.mobilenumber }}</p>
          </div>
          <div v-if="user.lastname">
            <p class="label">Овог:</p>
            <p class="info">{{ user.lastname }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="user.firstname">
            <p class="label">Нэр:</p>
            <p class="info">{{ user.firstname }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="user.register_number">
            <p class="label">Регистрийн дугаар:</p>
            <p class="info">{{ user.register_number }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="user.birthday">
            <p class="label">Тѳрсѳн огноо:</p>
            <p class="info">{{ user.birthday }}</p>
          </div>
        </div>
        <!--        <div class="detail-footer">-->
        <!--          <ic-button>Баталгаажуулах</ic-button>-->
        <!--        </div>-->
      </div>

      <div class="detail-item" v-if="user.disability">
        <div class="detail-header">
          <div class="sub-title">
            <div class="label font-400">Хөгжлийн бэрхшээлийн мэдээлэл</div>
          </div>
        </div>
        <div class="detail">
          <!-- <div>
            <p class="label">Банкны нэр:</p>
            <p class="info">{{ user.bank_name }}</p>
          </div>
          <p class="middle-border" /> -->
          <div v-if="user.disability_type">
            <p class="label">Хөгжлийн бэрхшээлийн төрөл:</p>
            <p class="info">{{user.disability_type }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="user.disability_percent">
            <p class="label">Хөдөлмөрийн чадвар алдалтын хувь хэмжээ:</p>
            <!--            <p v-if="user.tdb_account_number" class="info">{{ user.tdb_account_number }}</p>-->
            <p class="info">
              {{ user.disability_percent }}%
            </p>
          </div>
          <div v-if="user.disability_start_date && user.disability_end_date">
            <p class="label">Хөдөлмөрийн чадвар алдалтын хугацаа:</p>
            <!--            <p v-if="user.tdb_account_number" class="info">{{ user.tdb_account_number }}</p>-->
            <p class="info">
              ({{ user.disability_start_date }}) - ({{ user.disability_end_date }})
            </p>
          </div>

        </div>
        <!--        <div class="detail-footer">-->
        <!--          <ic-button>Баталгаажуулах</ic-button>-->
        <!--        </div>-->
      </div>

      <div class="detail-item">
        <div class="detail-header">
          <div class="sub-title">
            <div class="label font-400">Дансны мэдээлэл</div>
          </div>
        </div>
        <div class="detail">
          <!-- <div>
            <p class="label">Банкны нэр:</p>
            <p class="info">{{ user.bank_name }}</p>
          </div>
          <p class="middle-border" /> -->
          <div v-if="user.bank_account_holder">
            <p class="label">Дансны нэр:</p>
            <p class="info">{{ user.bank_account_holder }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="user.tdb_account_number || user.account_number">
            <p class="label">Дансны дугаар:</p>
            <!--            <p v-if="user.tdb_account_number" class="info">{{ user.tdb_account_number }}</p>-->
            <p v-if="user.account_number" class="info">
              {{ user.account_number }}
            </p>
          </div>
        </div>
        <!--        <div class="detail-footer">-->
        <!--          <ic-button>Баталгаажуулах</ic-button>-->
        <!--        </div>-->
      </div>

      <div class="detail-item">
        <div class="detail-header">
          <div class="sub-title">
            <div v-if="date" class="label font-400">Арилжааны мэдээлэл</div>
            <div v-else class="label font-400">
              Арилжааны эрх үүсээгүй байна.
            </div>
          </div>
        </div>
        <div v-if="date" class="detail">
          <div v-if="date.start_date">
            <p class="label">Арилжааны эрх үүссэн огноо:</p>
            <p class="info">{{ date.start_date | formatDate('dateTime') }}</p>
          </div>
          <p class="middle-border" />
          <div v-if="date.end_date">
            <p class="label">Арилжааны эрх дуусах огноо:</p>
            <p class="info">{{ date.end_date | formatDate('dateTime') }}</p>
          </div>
        </div>
        <!--        <div class="detail-footer">-->
        <!--          <ic-button>Баталгаажуулах</ic-button>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import RegistrationContainer from '../../components/RegistrationContainer'

export default {
  name: 'userDetail',
  components: {
    RegistrationContainer,
  },
  created() {
    if (this.user === null) {
      this.fetchUser()
    }
  },
  methods: {
    ...mapActions('user', ['fetchUser']),
  },
  computed: {
    ...mapState('user', ['user', 'date']),
  },
}
</script>
<style lang="scss" src="./UserDetail.scss"></style>
